import {
  Injectable,
} from '@angular/core';
import {
  FactsService,
  RulesEngineRunnerService,
} from '@o3r/rules-engine';
import {
  AppInitializationService,
} from '@refx/shared-services';
import {
  portalFacts,
} from './fact-factories/portal.fact';
import {
  PortalFacts,
} from './portal.facts';

@Injectable()
export class PortalFactsService extends FactsService<PortalFacts> {
  public facts = {
    portalFacts: portalFacts()(this.appInitializationService.getPortalFacts())
  };
  constructor(rulesEngine: RulesEngineRunnerService, private readonly appInitializationService: AppInitializationService) {
    super(rulesEngine);
  }
}
